import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hubspot': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M267.4 211.6l-163.2-114.7c-7.9 4.7-17 7.6-26.8 7.6-28.8 0-52.2-23.4-52.2-52.3 0-28.8 23.4-52.2 52.2-52.2 28.9 0 52.4 23.4 52.4 52.2 0 4.8-0.8 9.4-2 13.8 51.4 39.1 141.3 103.9 168.9 124.8 13.1-6.9 27.5-11.5 42.7-13.6v-61.2c-17.5-7.4-28.2-23.8-28.2-42.9 0-26.1 20.6-47.9 46.7-47.9 26.1 0 47 21.8 47 47.9 0 19.1-10.7 35.5-28.2 42.9v61.6c62.5 9.5 110.2 63.5 110.2 128.7 0 71.9-58.1 130.2-130 130.2-29.9 0-57.3-10-79.3-26.9l-50 50.2c1.3 3.9 1.9 7.9 1.9 12.1 0 10.7-4.2 20.9-11.8 28.5-7.7 7.7-17.8 11.6-28.6 11.6-10.7 0-20.9-4-28.5-11.6-7.6-7.6-11.8-17.7-11.8-28.5 0-10.8 4.2-21 11.8-28.6 7.6-7.6 17.7-11.8 28.5-11.8 4.9 0 9.6 0.9 14 2.5l49.5-49.8c-16.3-21.7-26-48.7-26-78 0-37.3 15.7-70.9 40.8-94.6zM356.9 375.2c38.1 0 69-30.9 69-69 0-38.1-30.9-69-69-69-38.1 0-69 30.9-69 69 0 38.1 30.9 69 69 69z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/hubspot.js
// module id = 728
// module chunks = 0